import {useRef} from 'react';

const DOUBLE_TAP_DELAY = 300;

function useDoubleTap(onDoubleTap?: () => void) {
    const lastTapRef = useRef<number | null>(null);

    return (event: React.MouseEvent) => {
        if(!onDoubleTap) return;
        const now = event.timeStamp;
        if(lastTapRef.current !== null && now - lastTapRef.current < DOUBLE_TAP_DELAY) {
            lastTapRef.current = null;
            onDoubleTap();
        } else {
            lastTapRef.current = now;
        }
    };
}

export default useDoubleTap;
